import { render, staticRenderFns } from "./HistoryVideo.vue?vue&type=template&id=974b0880&scoped=true"
import script from "./HistoryVideo.vue?vue&type=script&lang=js"
export * from "./HistoryVideo.vue?vue&type=script&lang=js"
import style0 from "./HistoryVideo.vue?vue&type=style&index=0&id=974b0880&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "974b0880",
  null
  
)

export default component.exports